module.exports = "https://static.energy5.com/_next/static/images/evc-why-85944a7c18f4282f916a876c85e60ab0.png";